import { MemberSubmission } from '../models/submissions/member-submission';
import { SubmissionStatusIdEnum } from '../models/enum/shared/submission-status-id.enum';
import { IpEmployerSubmission } from '../models/submissions/employer-submissions/ip-employer-submission';
import { EpEmployerSubmission } from '../models/submissions/employer-submissions/ep-employer-submission';
import { MemberSubmissionTypeEnum } from '../models/users/enum/member-submission-type-enum';

export class SubmissionUtils {
  static memberSubmissionsFilter(memberId: number, submissionTypes: MemberSubmissionTypeEnum[]): string {
    const memberFilter = `memberId eq ${memberId}`;
    if (!submissionTypes.length) return memberFilter;
    return `${memberFilter} and submissionTypeId in (${submissionTypes.join(',')})`;
  }

  static sortSubmissionsByRelevantDate(submissions: MemberSubmission[]) {
    return [...submissions].sort((a, b) => {
      const dateA = this.getRelevantDate(a);
      const dateB = this.getRelevantDate(b);

      if (!dateA && !dateB) return 0;
      if (!dateA) return 1;
      if (!dateB) return -1;

      return dateB.localeCompare(dateA);
    });
  }

  static getRelevantDate(submission: MemberSubmission | IpEmployerSubmission | EpEmployerSubmission): string | null {
    if (!(submission instanceof EpEmployerSubmission) && (submission.isApproved() || submission.isRejected())) {
      return submission.completedDate;
    }

    if (submission instanceof EpEmployerSubmission && submission.statusId === SubmissionStatusIdEnum.Completed) {
      return submission.submittedDate;
    }

    switch (submission.statusId) {
      case SubmissionStatusIdEnum.Pending:
        return submission.createdDate;
      case SubmissionStatusIdEnum.Cancelled:
      case SubmissionStatusIdEnum.Completed:
        return submission.completedDate;
      case SubmissionStatusIdEnum.Submitted:
      case SubmissionStatusIdEnum.InReview:
        return submission.submittedDate;
      default:
        return null;
    }
  }
}
